const publicImage = (filename: string) => {
  const basePath = __BASE_PATH__.endsWith("/") ? __BASE_PATH__ : `${__BASE_PATH__}/`;
  return `${basePath}assets/images/${filename}`;
};

export const MAIN_BANNER_IMAGE =
  publicImage("BackWeb_Principal.png");

export const HEADER_LOGO_IMAGE = publicImage("BIDG_MDS_Logo_Web.png");
export const HERO_LOGO_IMAGE = publicImage("Logo-envolvente-MDS.png");

export const MICROSITE_BANNER_IMAGES: Readonly<Record<string, string>> = {
  ti: publicImage("BackWeb_MDS_TI.png"),
  "administracion": publicImage("BackWeb_MDS_ADM.png"),
  "contraloria": publicImage("BackWeb_MDS_CONT.png"),
  "diseno-marketing": publicImage("BackWeb_MDS_DM.png"),
};

export function getMicrositeBannerImage(micrositeId: string): string {
  return MICROSITE_BANNER_IMAGES[micrositeId] ?? MAIN_BANNER_IMAGE;
}
